import { useNavigate } from "react-router-dom";

import { NewClientDialog } from "../../features/newClient";
import { ForeignNationalsDashboard } from "./ForeignNationalsDashboard";

/**
 * `/clients/new` (deep links): the New Client modal over the Clients list.
 * Closing it leaves the list; creating the client opens their profile.
 */
export const ForeignNationalCreate = () => {
  const navigate = useNavigate();
  return (
    <>
      <ForeignNationalsDashboard />
      <NewClientDialog
        open
        onOpenChange={(open) => {
          if (!open) navigate("/clients", { replace: true });
        }}
        onCreated={(uid) => navigate(`/clients/${uid}`, { replace: true })}
      />
    </>
  );
};
